module.exports = __webpack_public_path__ + "static/media/pdr3.cacaeab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/teacher_resources/pdr3.png
// module id = 1232
// module chunks = 0